export default {
  auditReport: {
    search: 'Buscar',
    reset: 'Restablecer',
    export: 'Exportar',
    all: 'Todos',
    exportSuccess: 'Exportación exitosa',
    exportError: 'Exportación fallida',
    fetchError: 'Consulta fallida',
    summary: {
      dateRange: 'Rango de Fechas (+8)',
      dateRequired: 'Seleccione rango de fechas',
      reportDate: 'Fecha del Reporte',
      branch: 'Rama',
      bet: 'Apuesta',
      payout: 'Pago',
      ggr: 'GGR',
      headcountOfActive: 'Recuento de Activos',
      totalBet: 'Apuesta Total',
      totalPayout: 'Pago Total',
      totalGgr: 'GGR Total',
      totalActiveHc: 'HC de Jugador Activo',
    },
    gameType: {
      dateRange: 'Rango de Fechas (+8)',
      dateRequired: 'Seleccione rango de fechas',
      reportDate: 'Fecha del Reporte',
      gameType: 'Tipo de Juego',
      bet: 'Apuesta',
      payout: 'Pago',
      ggr: 'GGR',
    },
    branchGameType: {
      dateRange: 'Rango de Fechas (+8)',
      dateRequired: 'Seleccione rango de fechas',
      reportDate: 'Fecha del Reporte',
      branch: 'Rama',
      gameType: 'Tipo de Juego',
      bet: 'Apuesta',
      payout: 'Pago',
      ggr: 'GGR',
    },
    provider: {
      dateRange: 'Rango de Fechas (+8)',
      dateRequired: 'Seleccione rango de fechas',
      reportDate: 'Fecha del Reporte',
      provider: 'Proveedor',
      gameType: 'Tipo de Juego',
      betCount: 'Total de Transacciones',
      bet: 'Apuesta',
      payout: 'Pago',
      ggr: 'GGR',
      total: 'Total',
    },
    providerGameType: {
      dateRange: 'Rango de Fechas (+8)',
      dateRequired: 'Seleccione rango de fechas',
      reportDate: 'Fecha del Reporte',
      provider: 'Proveedor de Juego',
      gameType: 'Tipo de Juego',
      platformType: 'Tipo de Plataforma',
      betCount: 'Total de Transacciones',
      bet: 'Apuesta',
      payout: 'Pago',
      ggr: 'GGR',
      total: 'Total',
    },
    gameOrder: {
      betTimeRange: 'Hora de Apuesta',
      dateRequired: 'Seleccione rango de hora de apuesta',
      dateRangeMaxDays: 'El rango de fechas no puede exceder {{days}} días.',
      providerFilter: 'Proveedor',
      betId: 'ID de Apuesta',
      betIdPlaceholder: 'Ingrese ID de Apuesta',
      partnerOrderId: 'ID de Orden del Socio',
      flowIdPlaceholder: 'Ingrese ID de Orden del Socio',
      userId: 'ID de Usuario',
      userIdPlaceholder: 'Ingrese ID de Usuario',
      userName: 'Nombre de Usuario',
      memberAccountPlaceholder: 'Ingrese Nombre de Usuario exacto',
      channelType: 'Tipo de Canal',
      outletId: 'ID de Salida',
      gameName: 'Nombre del Juego',
      gameType: 'Tipo de Juego',
      provider: 'Proveedor',
      platformType: 'Tipo de Plataforma',
      platformCode: 'Código de Plataforma',
      gameId: 'ID del Juego',
      gameIdPlaceholder: 'Ingrese ID del Juego',
      before: 'Antes',
      after: 'Después',
      bet: 'Apuesta',
      validBets: 'Apuestas Válidas',
      payouts: 'Pagos',
      winLose: 'Ganancia/Pérdida',
      refund: 'Reembolso',
      ggr: 'GGR',
      isBuyFeature: 'isBuyFeature',
      result: 'Resultado',
      status: 'Estado',
      betTime: 'Hora de Apuesta',
      settlementTime: 'Hora de Liquidación',
      detail: 'Operación',
      viewDetail: 'Ver Detalle',
      sportDetail: 'Detalle de Deporte',
      casinoDetail: 'Detalle de Casino',
      detailField: {
        // fallback basic info
        game_name: 'Nombre del Juego',
        game_id: 'ID del Juego',
        game_brand: 'Marca del Juego',
        game_type: 'Tipo de Juego',
        // casino detail (PAGCOR)
        liveGameRound: 'Ronda de Juego En Vivo',
        jackpotContribution: 'Contribución de Jackpot',
        jackpotPayout: 'Pago de Jackpot',
        houseRake: 'Comisión de la Casa',
        rakeCeiling: 'Límite de Comisión',
        blinds: 'Ciegos',
        netWin: 'Ganancia Neta',
        // sports event extra info (SportEventExtInfo)
        sportName: 'Deporte',
        leagueName: 'Liga',
        eventName: 'Evento',
        matchDateTime: 'Hora del Partido',
        handicap: 'Handicap',
        odds: 'Cuotas',
        finalScore: 'Marcador Final',
        itemStatus: 'Estado del Elemento',
        settlementStatus: 'Estado de Liquidación',
        isLive: 'En Vivo',
        yes: 'Sí',
        no: 'No',
      },
    },
    playerCount: {
      dateRange: 'Rango de Fechas (+8)',
      dateRequired: 'Seleccione rango de fechas',
      reportDate: 'Fecha del Reporte',
      dailyRegisteredHc: 'HC Registrado Diariamente',
      dailyKycVerifiedHc: 'HC Verificado por KYC Diariamente',
      dailyKycPendingHc: 'HC Pendiente/En Procesamiento de KYC Diariamente',
      activeHc: 'HC Activo',
      deactivatedHc: 'HC Desactivado/Inactivo',
    },
    playerAggregator: {
      dateRange: 'Rango de Fechas (+8)',
      dateRequired: 'Seleccione rango de fechas',
      reportDate: 'Fecha del Reporte',
      memberAccount: 'Cuenta de Miembro',
      playerIdPlaceholder: 'Coincidencia exacta',
      outletId: 'ID de Salida',
      channelType: 'Tipo de Canal',
      pageTotal: 'Total de la Página',
      depositCount: 'Número de Depósitos',
      depositAmount: 'Monto de Depósito',
      withdrawCount: 'Número de Retiros',
      withdrawAmount: 'Monto de Retiro',
      totalBetAmount: 'Monto Total de Apuesta',
      totalPayoutAmount: 'Monto Total de Pago',
      winLoseAmount: 'Monto de Ganancia/Pérdida',
    },
  },
};
